import { MsalProvider } from '@azure/msal-react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';

import { googleClientID, msalInstance } from '../../utils/addin/auth';

interface Props {
  children: React.ReactNode;
}

const OAuthProviders: React.FC<Props> = ({ children }) => {
  return (
    <MsalProvider instance={msalInstance}>
      <GoogleOAuthProvider clientId={googleClientID}>
        {children}
      </GoogleOAuthProvider>
    </MsalProvider>
  );
};

export default OAuthProviders;
